var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTotalGroups(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 57,
    viewBox: "0 0 56 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1265_2983)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.602 27.039V32.8234H30.6406V27.039C30.6406 23.8584 33.2433 21.2558 36.4238 21.2558H49.8141C52.9993 21.2558 55.602 23.8584 55.602 27.039Z",
    fill: "#64B9FC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.2324 21.2566L40.6714 23.8621L43.1211 21.2566L39.9875 19.0234L37.2324 21.2566ZM49.0065 21.2566L45.5675 23.8621L43.1211 21.2566L46.2515 19.0234L49.0065 21.2566Z",
    fill: "#CCE4FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.292 32.8238L45.2432 31.0169L44.8392 27.7496L44.432 24.4824H41.8073L41.4033 27.7496L40.9961 31.0169L41.9473 32.8238H44.292Z",
    fill: "#FE646F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.1209 24.4817H44.4316L44.756 22.9961L43.1209 21.2558L41.4824 22.9961L41.8069 24.4817H43.1209Z",
    fill: "#E41F2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.8525 28.0395V32.825H50.2812V28.0395C50.2812 27.6063 50.6326 27.2538 51.0669 27.2538C51.5012 27.2538 51.8525 27.6063 51.8525 28.0395Z",
    fill: "#31A7FB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.3148 20.6202C47.0306 20.6202 50.0593 16.8598 50.0593 12.25C50.0593 7.63702 47.0307 3.87671 43.3148 3.87671C39.6022 3.87671 36.5703 7.63702 36.5703 12.25C36.5704 16.8598 39.6022 20.6202 43.3148 20.6202Z",
    fill: "#FFCEBF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.3144 3.87689C47.0397 3.87689 50.0589 7.62452 50.0589 12.2502C50.0589 16.8727 47.0399 20.6203 43.3144 20.6203C43.1363 20.6203 42.9581 20.6108 42.7832 20.5949C46.2573 20.2577 48.9932 16.65 48.9932 12.2502C48.9932 7.8472 46.2573 4.23958 42.7832 3.90238C42.9598 3.8859 43.1371 3.87739 43.3144 3.87689Z",
    fill: "#FFB09E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.6401 13.4431C30.8056 8.79191 35.4535 0.167368 43.6231 0.568118C48.726 0.819462 53.0399 3.9022 52.0728 9.53632C51.5892 11.5628 50.8767 12.8417 49.9795 13.5257C50.0813 9.71756 49.2891 7.82471 48.0738 6.31676C46.8585 7.70385 45.2806 8.58826 43.2381 8.8396C38.2117 8.13337 36.1884 9.80681 36.6401 13.4431ZM3.36328 16.5417L8.91155 19.6434H15.1087L20.657 16.5417C19.5276 14.8301 19.5563 12.0719 20.078 8.87143C20.8033 4.4366 16.4989 0.692149 12.01 0.555431C7.52445 0.692259 3.22011 4.43671 3.94231 8.87143C4.46403 12.072 4.49586 14.8301 3.36328 16.5417Z",
    fill: "#407093"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.398438 32.8247H23.6222V26.233C23.6222 22.6094 20.6572 19.6445 17.0337 19.6445H6.99025C3.36666 19.6445 0.398547 22.6095 0.398547 26.233L0.398438 32.8247Z",
    fill: "#64B9FC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0103 28.808L15.128 19.6425H8.89258L12.0103 28.808Z",
    fill: "#F2FBFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.88672 14.9199H15.1349V19.6442H8.88672V14.9199Z",
    fill: "#FFCEBF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.7391 9.65449C17.843 10.189 17.8952 10.7324 17.8949 11.277C17.8949 15.225 15.194 18.4254 11.8631 18.4254C8.53221 18.4254 5.82813 15.225 5.82813 11.277C5.82747 10.47 5.94431 9.66735 6.17496 8.89411C6.31178 8.43605 6.74119 8.14336 7.21522 8.18788C11.001 8.53788 13.3043 7.66299 14.3096 5.71283C14.316 7.8697 15.8429 9.61949 17.7391 9.65449Z",
    fill: "#FFCEBF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.53756 23.1121L12.0095 28.8099L8.89175 19.6445H6.98939C6.51536 19.6445 6.05095 19.6953 5.60547 19.7908L7.88966 21.8905L6.53756 23.1121Z",
    fill: "#31A7FB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.4836 23.1121L12.0117 28.8099L15.1295 19.6445H17.0318C17.509 19.6445 17.9704 19.6953 18.4189 19.7908L16.1347 21.8905L17.4836 23.1121Z",
    fill: "#31A7FB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.7826 46.5014V52.8895H14.2188V46.5014C14.2188 42.9897 17.0918 40.1132 20.6069 40.1132H35.3944C38.9095 40.1132 41.7826 42.9897 41.7826 46.5014Z",
    fill: "#CCE4FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.4961 40.1127L25.2946 42.9919L27.9987 40.1127L24.5405 37.6503L21.4961 40.1127ZM34.5013 40.1127L30.7028 42.9919L27.9987 40.1127L31.4569 37.6503L34.5013 40.1127Z",
    fill: "#9DC6FB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.2957 52.8876L30.3455 50.8898L29.8969 47.2853L29.4484 43.6777H26.5533L26.1048 47.2853L25.6562 50.8898L26.706 52.8876H29.2957Z",
    fill: "#FE646F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.9984 43.6777H29.446L29.8054 42.036L27.9984 40.1113L26.1914 42.036L26.5509 43.6777H27.9984Z",
    fill: "#E41F2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0079 47.6048V52.8886H18.4355V47.6048C18.4355 47.1705 18.788 46.8181 19.2212 46.8181C19.4298 46.8182 19.6299 46.9011 19.7774 47.0486C19.925 47.1961 20.0079 47.3962 20.0079 47.6048Z",
    fill: "#9DC6FB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.2171 39.4119C32.3179 39.4119 35.6647 35.257 35.6647 30.1668C35.6647 25.0735 32.3179 20.9218 28.2171 20.9218C24.1163 20.9218 20.7695 25.0735 20.7695 30.1668C20.7696 35.257 24.1164 39.4119 28.2171 39.4119Z",
    fill: "#FFCEBF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.2175 20.9218C32.3309 20.9218 35.665 25.0608 35.665 30.1668C35.665 35.2729 32.3309 39.4119 28.2175 39.4119C28.0203 39.4119 27.8229 39.4024 27.6289 39.3832C31.4656 39.011 34.4879 35.0247 34.4879 30.1668C34.4879 25.3058 31.4657 21.3227 27.6289 20.9505C27.8245 20.9314 28.0209 20.9218 28.2175 20.9218Z",
    fill: "#FFB09E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.8444 31.4842C14.4022 26.3495 19.5336 16.8246 28.556 17.2668C34.1901 17.5436 38.9558 20.9476 37.8869 27.1703C37.3523 29.41 36.5666 30.8225 35.574 31.5797C35.6854 27.3707 34.8105 25.2807 33.468 23.6168C32.1287 25.147 30.3853 26.1268 28.1297 26.4005C22.5782 25.6209 20.3449 27.4725 20.8444 31.4842Z",
    fill: "#407093"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.6347 38.3313V39.8234C45.5575 40.017 46.4359 40.3817 47.2244 40.8987L48.2806 39.8425C49.153 40.454 49.912 41.213 50.5235 42.0853L49.4672 43.1415C49.9842 43.93 50.349 44.8083 50.5425 45.7311H52.0346C52.1268 46.2465 52.1714 46.7778 52.1714 47.3186C52.1714 47.8594 52.1269 48.3907 52.0346 48.906H50.5425C50.349 49.8288 49.9842 50.7072 49.4672 51.4957L50.5235 52.552C49.912 53.4243 49.153 54.1833 48.2806 54.7948L47.2244 53.7417C46.4348 54.2559 45.5567 54.6194 44.6347 54.8138V56.3091C44.1194 56.3981 43.5881 56.4459 43.0473 56.4459C42.5064 56.4459 41.9752 56.3982 41.4598 56.3091V54.8138C40.5376 54.62 39.6595 54.2564 38.8701 53.7417L37.8139 54.7948C36.9413 54.1825 36.1814 53.4237 35.5679 52.552L36.6241 51.4957C36.1094 50.7064 35.7459 49.8282 35.552 48.906H34.0567C33.9677 48.3907 33.9199 47.8594 33.9199 47.3186C33.9199 46.7777 33.9676 46.2465 34.0567 45.7311H35.552C35.7459 44.809 36.1094 43.9309 36.6241 43.1415L35.5679 42.0853C36.1814 41.2136 36.9413 40.4548 37.8139 39.8425L38.8701 40.8987C39.6586 40.3817 40.537 40.017 41.4598 39.8234V38.3313C41.9752 38.2391 42.5064 38.1913 43.0473 38.1913C43.5881 38.1913 44.1194 38.2391 44.6347 38.3313Z",
    fill: "#64B9FC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.0484 42.7559C45.568 42.7559 47.6104 44.7984 47.6104 47.318C47.6104 49.8376 45.5679 51.88 43.0484 51.88C40.5287 51.88 38.4863 49.8375 38.4863 47.318C38.4863 44.7984 40.5287 42.7559 43.0484 42.7559Z",
    fill: "#F2FBFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.7409 9.65449C17.8448 10.189 17.897 10.7324 17.8967 11.277C17.8967 15.225 15.1958 18.4254 11.8649 18.4254C11.7195 18.4248 11.5741 18.4196 11.4291 18.4095C14.5595 18.1455 17.0282 15.0532 17.0282 11.277C17.0282 10.7202 16.974 10.1762 16.8723 9.65449C15.2912 9.62583 13.9646 8.39788 13.5669 6.73724C13.8659 6.4382 14.1141 6.09466 14.3113 5.71283C14.3178 7.8697 15.8447 9.61949 17.7409 9.65449ZM6.83203 8.22605C6.95678 8.1892 7.08737 8.17625 7.21692 8.18788C7.60181 8.22288 7.97084 8.24836 8.32402 8.25788C7.85644 8.27374 7.3602 8.26105 6.83203 8.22605Z",
    fill: "#FFB09E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.0474 42.7559C45.5671 42.7559 47.6095 44.7984 47.6095 47.318C47.6095 49.8376 45.567 51.88 43.0474 51.88C42.9393 51.88 42.8343 51.8768 42.7324 51.8705C45.1026 51.7083 46.9764 49.7326 46.9764 47.318C46.9764 44.9065 45.1026 42.9309 42.7324 42.7686C42.8372 42.7595 42.9423 42.7553 43.0474 42.7559Z",
    fill: "#CCE4FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1265_2983"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalGroups);
export default __webpack_public_path__ + "static/media/totalGroups.cedede8269019f09face16a691220aad.svg";
export { ForwardRef as ReactComponent };